import { createI18n } from 'vue-i18n'
import {
  ELocale,
  DEFAULT_LOCALE,
  LOCALE_STORAGE_KEY,
  isSupportedLocale,
} from '@/types/ELocale'

import ru from '@/locales/ru.json'
import en from '@/locales/en.json'
import { ru as vuetifyRu, en as vuetifyEn } from 'vuetify/locale'

type MessageSchema = typeof ru & { $vuetify: typeof vuetifyRu }

function readInitialLocale(): ELocale {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (isSupportedLocale(stored)) {
      return stored
    }
  } catch {
    // localStorage may be unavailable
  }
  return DEFAULT_LOCALE
}

export const i18n = createI18n<[MessageSchema], ELocale, false>({
  legacy: false,
  locale: readInitialLocale(),
  fallbackLocale: ELocale.RU,
  messages: {
    [ELocale.RU]: { ...ru, $vuetify: vuetifyRu },
    [ELocale.EN]: { ...en, $vuetify: vuetifyEn },
  },
  missingWarn: false,
  fallbackWarn: false,
})

export function tGlobal(
  key: string,
  named?: Record<string, string | number>,
): string {
  return named ? (i18n.global.t(key, named) as string) : (i18n.global.t(key) as string)
}
